import { Input } from "@babackapp/ui/components/input";
import { FormField } from "@babackapp/ui/components/form";
import { useWorkflowForm } from "../../context/workflows-editor-workflows-context";
import { PanelInlineContent } from "../../lib/panel/panel-inline-content";
import { useTranslation } from "react-i18next";

// Must match backend: apps/baback-end/src/modules/tracking-system/constants/unfulfilled-orders.constants.ts
const UNFULFILLED_ORDER_VALIDATION = {
  MIN_DAYS: 1,
  MAX_DAYS: 30,
  DEFAULT_DAYS: 3,
} as const;

export function PanelOrderNotFulfilled() {
  const form = useWorkflowForm();
  const { t } = useTranslation("trackoffice");

  return (
    <PanelInlineContent title={t("workflowsEditor.panels.minDaysSinceCreation.title")}>
      <FormField
        control={form.control}
        name="workflow.trigger.data.config.minDaysSinceCreation"
        render={({ field }) => {
          return (
            <Input
              type="number"
              min={UNFULFILLED_ORDER_VALIDATION.MIN_DAYS}
              max={UNFULFILLED_ORDER_VALIDATION.MAX_DAYS}
              className="w-20 h-8 text-xs"
              placeholder={t("workflowsEditor.panels.minDaysSinceCreation.placeholder")}
              value={(field.value as number | undefined) || ""}
              onChange={(e) => field.onChange(parseInt(e.target.value, 10) || UNFULFILLED_ORDER_VALIDATION.MIN_DAYS)}
            />
          );
        }}
      />
    </PanelInlineContent>
  );
}
